import { Box } from '@material-ui/core';
import { KeyboardBackspace } from '@material-ui/icons';
import { lazy, Suspense } from 'react';

import { FeedLayout } from 'shared/components/layouts';
import { ButtonLink, FeedSkeleton } from 'shared/components/ui';
import { DISCOUNTS, ROUTES, SUPPORTERS } from 'shared/constants';
import { CommunitySidebar } from 'shared/features/community-sidebar';
import { SearchProvider } from 'shared/features/search';

import { GroupsPostsFilter } from '../components/GroupsPostsFilter';
import { JoinedGroupList } from '../components/JoinedGroupList';

const GroupDetailsHeader = lazy(() => import('../components/GroupDetailsHeader'));
const GroupDetailsContent = lazy(() => import('../components/GroupDetailsContent'));

export function GroupDetailsPage() {
  return (
    <SearchProvider>
      <FeedLayout
        sidebar={
          <Box display="flex" flexDirection="column" gridGap="1rem">
            <GroupsPostsFilter />
            <CommunitySidebar items={[SUPPORTERS, DISCOUNTS]} />
            <JoinedGroupList />
          </Box>
        }
      >
        <Box display="flex" flexDirection="column" gridGap="2rem">
          <Box>
            <ButtonLink
              variant="text"
              size="small"
              startIcon={<KeyboardBackspace />}
              to={ROUTES.user.groups.index}
            >
              Go Back
            </ButtonLink>
          </Box>

          <Suspense fallback={<FeedSkeleton count={1} />}>
            <GroupDetailsHeader />
          </Suspense>

          <Suspense fallback={<FeedSkeleton />}>
            <GroupDetailsContent />
          </Suspense>
        </Box>
      </FeedLayout>
    </SearchProvider>
  );
}
